import AxiosService from '../AxiosService';

const CLiENT_ENDPOINT = "/api/v1/clients"

export default class SharedClientService {
  constructor() {
    this.service = new AxiosService();
  }

  resolveClients() {
    return this.service.get(CLiENT_ENDPOINT);
  }
}
